import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	companyManagedTitle: {
		id: 'spa-apps-sidebar-servicedesk.menu.footer.company-managed-title',
		defaultMessage: "You're in a company-managed project",
		description: 'This is what the user sees when they are on a company-managed project',
	},
	// Rebrand
	titleTeamManaged: {
		id: 'spa-apps-sidebar-servicedesk.menu.footer.title-team-managed',
		defaultMessage: "You're in a team-managed project",
		description: 'This is what the user sees when they are on a next-gen project',
	},
});
